import { Control, Controller } from 'react-hook-form';
import { TmdxTextarea } from '@ds';

interface FormLinkDescriptionProps {
  formFieldName: string;
  control: Control;
  disabled?: boolean;
  maxLength?: number;
}

const FormLinkDescription = ({ formFieldName, control, disabled, maxLength }: FormLinkDescriptionProps) => {
  return (
    <Controller
      name={`${formFieldName}.description`}
      control={control}
      render={({ field, fieldState: { invalid, error } }) => (
        <TmdxTextarea
          placeholder="Link text description"
          aria-label="Enter link description"
          fullWidth
          disableAnimation
          minRows={3}
          isDisabled={disabled}
          isInvalid={invalid}
          errorMessage={error?.message}
          maxLength={maxLength}
          {...field}
        />
      )}
    />
  );
};

export default FormLinkDescription;
